/** /comms/inbox — route stub (Agent U1); component in inbox.lazy.tsx. */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/comms/inbox')({});
